// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  background-color: #2D2A2C;
  padding: 24px;
  margin-top: 60px;
  width: 100%;
}
footer .cta {
  color: #fff !important;
  text-decoration: underline !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/footer.scss","webpack://./src/assets/styles/colors.scss"],"names":[],"mappings":"AACA;EACI,yBCKK;EDJL,aAAA;EAGA,gBAAA;EACA,WAAA;AAFJ;AAGI;EACI,sBAAA;EACA,qCAAA;AADR","sourcesContent":["@import  './colors.scss';\nfooter{\n    background-color: $dark-bg;\n    padding: 24px;\n    // position: absolute;\n    // bottom: 0;\n    margin-top: 60px;\n    width: 100%;\n    .cta{\n        color:#fff !important;\n        text-decoration: underline !important;\n    }\n    \n}","$primary-color: #FB263B;\n$primary-color-hover: #ED4E5C;\n$primary-color-press: #F499A1;\n$interaction-dark-bg:#fff;\n$hover-dark-bg:#D5D4D5;\n$press-dark-bg:#969596;\n$light-bg:#F5F5F7;\n$dark-bg:#2D2A2C;\n$text-color:#121010;\n$subText-color:#7D7779;\n$success:#7BBE6A;\n$error:#FF8A00;\n$input-bg:#FAFAFA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
